import { hexToRgba } from "./canvasHelpers.js";

// The eyebrow without its colour, for a caller that tones it (a warning strip,
// an inactive tab) and must still match the sidebar's size, case and tracking.
export const EYEBROW_BASE = "text-[11px] leading-[1.1] tracking-[0.06em] uppercase";

export const EYEBROW_CLASS = `${EYEBROW_BASE} text-[color:var(--eyebrow)]`;

export const NOTE_CLASS =
  "text-[11px] leading-[1.22] text-[color:var(--muted-soft)]";

export const PROMPT_BODY_CLASS =
  "mt-2 text-[12px] leading-[1.28] text-[color:var(--muted)]";

export const ROOT_NAV_TITLE_CLASS =
  "whitespace-nowrap text-[12px] leading-[1.08] font-medium tracking-[0.1em] uppercase";

export const ROOT_NAV_META_CLASS =
  "whitespace-nowrap text-[11px] leading-[1.08] tracking-[0.06em] text-[color:var(--muted)] uppercase";

export const CONTROL_TEXT_CLASS =
  "text-[11px] leading-[1.08] text-[color:var(--muted)]";

export const ACTION_TEXT_CLASS =
  "text-[11px] leading-[1.08] tracking-[0.08em] uppercase";

export const SVG_FILL_CLASS = "[&_svg]:h-full [&_svg]:w-full";

// Resolved theme green for renderers that take LITERAL colors (canvas
// strokes, chart layer props) where a CSS var() string doesn't reach.
// Falls back to the legacy brand green when no stylesheet is attached
// (tests, very-early renders).
const FALLBACK_GREEN = "#7fa16c";
export function themeGreen() {
  try {
    const v = getComputedStyle(document.documentElement).getPropertyValue("--green").trim();
    return v || FALLBACK_GREEN;
  } catch {
    return FALLBACK_GREEN;
  }
}

// themeGreen() with alpha, as an rgba() literal (canvas fills). The
// hex→rgba parse is canvasHelpers' hexToRgba; that helper passes non-#
// strings through UNCHANGED, and an un-alphaed pass-through would paint
// an opaque fill — so anything it can't alpha falls back to the legacy
// translucent green.
export function themeGreenAlpha(alpha) {
  const color = themeGreen();
  const rgba = hexToRgba(color, alpha);
  return rgba === color ? `rgba(127, 161, 108, ${alpha})` : rgba;
}
